<template>
	<div>
		<div style="text-align: right; padding-bottom: 20px;">
			<el-link type="primary" @click="exportXls">导出XLS</el-link>
		</div>
		<table id="table" class="dtable">
			<tr>
				<td>
					类别

				</td>
				<td>
					院系

				</td>
				<td>
					专业名称

				</td>
				<td>
					{{year}}年专业计划数
				</td>
				<td>
					已登记人数(交1000)

				</td>
				<td>
					已登记人数(交3800)

				</td>
				<td>
					投档人数

				</td>
				<td>
					小计

				</td>
				<td>
					1000占计划比例

				</td>
				<td>
					3800占计划比例

				</td>
				<td>
					已缴费占计划比例

				</td>



			</tr>
			<tr v-for="(item,idx) in ShowDataList1 " :key="'n'+idx">
				<td :rowspan="ShowDataList1.length" v-if="idx==0">
					五年制高职
				</td>
				<td :rowspan="item.rowspan+1" v-if="item.rowspan">
					{{item.yuanxi}}
				</td>
				<td>
					{{item.title}}
				</td>
				<td>
					{{item.plan}}
				</td>
				<td>
					{{item.fee1000}}
				</td>
				<td>
					{{item.fee3800}}
				</td>
				<td>
					{{item.toudang}}
				</td>
				<td>
					{{item.fee1000+item.fee3800}}
				</td>
				<td>
					{{item.percent_1000}}
				</td>
				<td>
					{{item.percent_3800}}
				</td>
				<td>
					{{item.percent_fee}}
				</td>



			</tr>
			<tr v-for="(item,idx) in heji_1 " :key="'hj'+idx">
				<td colspan="3">
					五年制高职（合计）
				</td>

				<td>
					{{item.plan}}
				</td>
				<td>
					{{item.fee1000}}
				</td>
				<td>
					{{item.fee3800}}
				</td>
				<td>
					{{item.toudang}}
				</td>
				<td>
					{{item.fee1000+item.fee3800}}
				</td>
				<td>
					{{item.percent_1000}}
				</td>
				<td>
					{{item.percent_3800}}
				</td>
				<td>
					{{item.percent_fee}}
				</td>
			</tr>
			<tr v-for="(item,idx) in ShowDataList2 " :key="'m'+idx">
				<td :rowspan="ShowDataList2.length" v-if="idx==0">
					3+3专科
				</td>
				<td :rowspan="item.rowspan+1" v-if="item.rowspan">
					{{item.yuanxi}}
				</td>
				<td>
					{{item.title}}
				</td>
				<td>
					{{item.plan}}
				</td>
				<td>
					{{item.fee1000}}
				</td>
				<td>
					{{item.fee3800}}
				</td>
				<td>
					{{item.toudang}}
				</td>
				<td>
					{{item.fee1000+item.fee3800}}
				</td>
				<td>
					{{item.percent_1000}}
				</td>
				<td>
					{{item.percent_3800}}
				</td>
				<td>
					{{item.percent_fee}}
				</td>



			</tr>
			<tr v-for="(item,idx) in heji_2 " :key="'hj2'+idx">
				<td colspan="3">
					3+3专科（合计）
				</td>
			
				<td>
					{{item.plan}}
				</td>
				<td>
					{{item.fee1000}}
				</td>
				<td>
					{{item.fee3800}}
				</td>
				<td>
					{{item.toudang}}
				</td>
				<td>
					{{item.fee1000+item.fee3800}}
				</td>
				<td>
					{{item.percent_1000}}
				</td>
				<td>
					{{item.percent_3800}}
				</td>
				<td>
					{{item.percent_fee}}
				</td>
			</tr>
			
			<tr v-for="(item,idx) in zongji " :key="'hj2'+idx">
				<td colspan="3">
					总合计
				</td>
			
				<td>
					{{item.plan}}
				</td>
				<td>
					{{item.fee1000}}
				</td>
				<td>
					{{item.fee3800}}
				</td>
				<td>
					{{item.toudang}}
				</td>
				<td>
					{{item.fee1000+item.fee3800}}
				</td>
				<td>
					{{item.percent_1000}}
				</td>
				<td>
					{{item.percent_3800}}
				</td>
				<td>
					{{item.percent_fee}}
				</td>
			</tr>
		</table>

	</div>
</template>

<script>
	import XLSX from 'xlsx'
	export default {

		data() {
			return {
				year: localStorage.getItem("year"),
				students: [],
				ShowDataList1: [],
				ShowDataList2: [],
				count1: 0,
				count2: 0,
				heji_1: [],
				heji_2: [],
				zongji: [],
				luquStu:[]
			}
		},
		mounted() {
			this.getLuqu();
			
		},
		methods: {
			getLuqu(){
				
				this.$http.post('/api/sch_luqu_marjor_stu', {}).then(res => {
					this.luquStu = res.data
					this.getData()
				})
			},
			getData() {
				this.$http.post('/api/sch_area_major_data_dj', {
					status: 0
				}).then(res => {
					//this.students = res.data
					//先区分下五年高职和3+3的
					$("#loading").show();
					let FiveYearsData = [],
						ThreeYearsData = [];
					for (let item of res.data.majors) {
						if (item.item_desc.indexOf("五年") >= 0) {
							FiveYearsData.push(item)
						} else if (item.item_desc.indexOf("3+3") >= 0) {
							ThreeYearsData.push(item)
						}
					}

					//计算系部
					let xibu_5year = {};
					for (let m of FiveYearsData) {
						if (!xibu_5year[m.yuanxi]) {
							xibu_5year[m.yuanxi] = [m]
						} else {
							xibu_5year[m.yuanxi].push(m)
						}
					}

					//计算系部
					let xibu_3year = {};
					for (let m of ThreeYearsData) {
						if (!xibu_3year[m.yuanxi]) {
							xibu_3year[m.yuanxi] = [m]
						} else {
							xibu_3year[m.yuanxi].push(m)
						}
					}


					let ShowDataList1 = [],
						ShowDataList2 = [];
					let heji_1 = {
						title: '合计',
						plan: 0,
						fee1000: 0,
						fee3800: 0,
						toudang: 0,
						percent_1000: 0,
						percent_3800: 0,
						percent_fee: 0,
					}
					let heji_2 = {
						title: '合计',
						plan: 0,
						fee1000: 0,
						fee3800: 0,
						toudang: 0,
						percent_1000: 0,
						percent_3800: 0,
						percent_fee: 0,
					}

					for (let k in xibu_5year) {
						//合并行数
						xibu_5year[k][0].rowspan = xibu_5year[k].length
						this.count1 += xibu_5year[k].length + 1
						let heji = {
							title: '小计',
							plan: 0,
							fee1000: 0,
							fee3800: 0,
							toudang: 0,
							percent_1000: 0,
							percent_3800: 0,
							percent_fee: 0,
						}
						for (let m of xibu_5year[k]) {
							m.plan = this.getMajorPlan(m.id, res.data.areaplan);
							m.fee1000 = this.getFee(m.id, res.data.fee1000);
							m.fee3800 = this.getFee(m.id, res.data.fee3800);
							m.toudang = this.getToudang(m.id, this.luquStu);
							if (m.plan > 0) {
								m.percent_1000 = parseInt(m.fee1000 / m.plan * 10000) / 100 + "%";
								m.percent_3800 = parseInt(m.fee3800 / m.plan * 10000) / 100 + "%";
								m.percent_fee = parseInt((m.fee3800 + m.fee1000) / m.plan * 10000) / 100 + "%";
							}
							heji.plan += m.plan;
							heji.fee1000 += m.fee1000;
							heji.fee3800 += m.fee3800;
							heji.toudang += m.toudang;
							ShowDataList1.push(m)

						}
						if (heji.plan > 0) {
							heji.percent_1000 = parseInt(heji.fee1000 / heji.plan * 10000) / 100 + "%";
							heji.percent_3800 = parseInt(heji.percent_3800 / heji.plan * 10000) / 100 + "%";
							heji.percent_fee = parseInt((heji.fee3800 + heji.fee1000) / heji.plan * 10000) / 100 +
								"%";
						}
						ShowDataList1.push(heji)
						heji_1.plan += heji.plan;
						heji_1.fee1000 += heji.fee1000;
						heji_1.fee3800 += heji.fee3800;
						heji_1.toudang += heji.toudang;

					}
					if (heji_1.plan > 0) {
						heji_1.percent_1000 = parseInt(heji_1.fee1000 / heji_1.plan * 10000) / 100 + "%";
						heji_1.percent_3800 = parseInt(heji_1.percent_3800 / heji_1.plan * 10000) / 100 + "%";
						heji_1.percent_fee = parseInt((heji_1.fee3800 + heji_1.fee1000) / heji_1.plan * 10000) /
							100 +
							"%";
					}

					for (let k in xibu_3year) {
						this.count2 += xibu_3year[k].length + 1
						//合并行数
						xibu_3year[k][0].rowspan = xibu_3year[k].length
						let heji = {
							title: '小计',
							plan: 0,
							fee1000: 0,
							fee3800: 0,
							toudang: 0,
							percent_1000: 0,
							percent_3800: 0,
							percent_fee: 0,
						}
						for (let m of xibu_3year[k]) {
							m.plan = this.getMajorPlan(m.id, res.data.areaplan);
							m.fee1000 = this.getFee(m.id, res.data.fee1000);
							m.fee3800 = this.getFee(m.id, res.data.fee3800);
							m.toudang = this.getToudang(m.id, this.luquStu);
							if (m.plan > 0) {
								m.percent_1000 = parseInt(m.fee1000 / m.plan * 10000) / 100 + "%";
								m.percent_3800 = parseInt(m.fee3800 / m.plan * 10000) / 100 + "%";
								m.percent_fee = parseInt((m.fee3800 + m.fee1000) / m.plan * 10000) / 100 + "%";
							}
							heji.plan += m.plan;
							heji.fee1000 += m.fee1000;
							heji.fee3800 += m.fee3800;
							heji.toudang += m.toudang;
							ShowDataList2.push(m)
						}
						if (heji.plan > 0) {
							heji.percent_1000 = parseInt(heji.fee1000 / heji.plan * 10000) / 100 + "%";
							heji.percent_3800 = parseInt(heji.fee3800 / heji.plan * 10000) / 100 + "%";
							heji.percent_fee = parseInt((heji.fee3800 + heji.fee1000) / heji.plan * 10000) / 100 +
								"%";
						}
						ShowDataList2.push(heji)
						heji_2.plan += heji.plan;
						heji_2.fee1000 += heji.fee1000;
						heji_2.fee3800 += heji.fee3800;
						heji_2.toudang += heji.toudang;

					}
					if (heji_2.plan > 0) {
						heji_2.percent_1000 = parseInt(heji_2.fee1000 / heji_2.plan * 10000) / 100 + "%";
						heji_2.percent_3800 = parseInt(heji_2.fee3800 / heji_2.plan * 10000) / 100 + "%";
						heji_2.percent_fee = parseInt((heji_2.fee3800 + heji_2.fee1000) / heji_2.plan * 10000) / 100 + "%";
					}
					this.ShowDataList1 = ShowDataList1
					this.ShowDataList2 = ShowDataList2
					this.heji_1 = [heji_1];
					this.heji_2 = [heji_2];
					let zongji = JSON.parse(JSON.stringify(heji_1))
					zongji.plan += heji_2.plan;
					zongji.fee1000 += heji_2.fee1000;
					zongji.fee3800 += heji_2.fee3800;
					zongji.toudang += heji_2.toudang;
					if (zongji.plan > 0) {
						zongji.percent_1000 = parseInt(zongji.fee1000 / zongji.plan * 10000) / 100 + "%";
						zongji.percent_3800 = parseInt(zongji.fee3800 / zongji.plan * 10000) / 100 + "%";
						zongji.percent_fee = parseInt((zongji.fee3800 + zongji.fee1000) / zongji.plan * 10000) / 100 + "%";
					}
					this.zongji = [zongji]

					this.$nextTick(function() {
						$("#loading").hide();
					})



				})
			},
			getMajorPlan(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.num) {
						total += item.num
					}
				}
				return total
			},
			getFee(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.num) {
						total += item.num
					}
				}
				return total
			},
			getToudang(major_id, data) {
				let total = 0;
				for (let item of data) {
					if (major_id == item.major_id && item.stu_num) {
						total += item.stu_num
					}
				}
				return total
			},


			exportXls() {
				let workbook = XLSX.utils.table_to_book(document.getElementById('table'))
				try {
					XLSX.writeFile(workbook, '已缴费人数统计表' + parseInt(Math.random() * 10000) + '.xlsx');
				} catch (e) {
					console.log(e, workbook);
				}
			}
		},
	}
</script>

<style scoped="scoped">
	.datatable {
		background-color: #E4E7ED;
		width: 100%;
	}

	.datatable td {
		background-color: #fff;
		text-align: center;
		padding: 10px 0;
	}
</style>
